import { FunctionComponent } from "react";
import Cards from "../../templates/cards/cards";
import "./body.css";

const Body: FunctionComponent = () => (
  <div className="container__body">
    <Cards />
  </div>
);

export default Body;
